// src/slices/agentManagement/thunk.ts
// Async thunks for Agent Management

import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAgents,
  createNewAgent,
  updateExistingAgent,
  checkAgentCodeAvailability,
} from "../../helpers/fakebackend_helper";
import { IAgent, AgentFilter } from "./types";

// Fetch agents list
export const fetchAgents = createAsyncThunk(
  "AgentManagement/fetchAgents",
  async (params: AgentFilter, { rejectWithValue }) => {
    try {
      const response = await getAgents(params);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch agents"
      );
    }
  }
);

// Create new agent - NO TOAST HERE (handled in component)
export const createAgent = createAsyncThunk(
  "AgentManagement/createAgent",
  async (data: IAgent, { rejectWithValue }) => {
    try {
      const response = await createNewAgent(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Update existing agent - NO TOAST HERE (handled in component)
export const updateAgent = createAsyncThunk(
  "AgentManagement/updateAgent",
  async (data: IAgent, { rejectWithValue }) => {
    try {
      const response = await updateExistingAgent(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Check code uniqueness
export const checkAgentCode = createAsyncThunk(
  "AgentManagement/checkCode",
  async (code: string, { rejectWithValue }) => {
    try {
      const response = await checkAgentCodeAvailability(code);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);